import { render, staticRenderFns } from "./nutritionMealDialogNewProduct.vue?vue&type=template&id=716beee9&scoped=true"
import script from "./nutritionMealDialogNewProduct.vue?vue&type=script&lang=js"
export * from "./nutritionMealDialogNewProduct.vue?vue&type=script&lang=js"
import style0 from "./nutritionMealDialogNewProduct.vue?vue&type=style&index=0&id=716beee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716beee9",
  null
  
)

export default component.exports